export default "__VITE_ASSET__Qtd0rqCX__"